import { getPrivileges } from '@mntn-dev/authorization-types'
import type {
  TeamDomainSelectModel,
  UserDomainSelectModel,
} from '@mntn-dev/domain-types'

import type { Principal } from './principal.ts'

export const NormalizePrincipal = ({
  authz,
  profile,
}: {
  authz: Principal['authz']
  profile: Principal['profile']
}) => ({
  ...authz,
  ...profile,
})

export const DenormalizePrincipal = ({
  userId,
  firstName,
  lastName,
  emailAddress,
  ...authz
}: Principal['authz'] & Principal['profile']) => ({
  profile: { userId, firstName, lastName, emailAddress },
  authz,
})

export const PrincipalFromUser = ({
  user,
  teams,
  isActive,
}: {
  user: UserDomainSelectModel
  teams: TeamDomainSelectModel[]
  isActive: boolean
}): Principal => {
  const {
    userId,
    emailAddress,
    organizationId,
    organizationType,
    roles,
    firstName,
    lastName,
    displayName,
    signUpTimestamp,
  } = user

  return {
    authz: {
      organizationId,
      organizationType,
      teamIds: teams.map((team) => team.teamId),
      privileges: getPrivileges(organizationType, roles),
      isActive,
      partnerPrograms: [],
    },
    profile: {
      userId,
      emailAddress,
      firstName,
      lastName,
      displayName,
      signUpTimestamp,
    },
  }
}
